// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__F2Bq4","right":"Footer_right__2JDLp","buttons":"Footer_buttons__2dnpA"};